/* JHERR · Tarjetas de colección: encuadre parejo de fotos y cambio de variante.
   1) Encuadre: mide dónde está el reloj dentro de cada foto (fondo claro alrededor) y lo acerca
      para que todos se vean del mismo tamaño en la tarjeta. La medida se guarda en el navegador,
      así la siguiente visita no vuelve a calcular. Fotos con fondo de ambiente se dejan como están.
   2) Variantes: al tocar una muestra cambia foto (con fundido), precio, enlace y botón,
      sin entrar a la ficha.
   v2 (04-nov): el encuadre se aplica cuando la tarjeta está por entrar en pantalla y toma el
   tamaño de la caja del IntersectionObserver. Antes se medía cada foto una por una, y cada medida
   obligaba al navegador a recalcular toda la página: con muchas tarjetas cargadas, al bajar o al
   esconderse la barra del navegador en el celular, la colección se ponía lenta. */
(function () {
  'use strict';
  if (window.__jhCardPlus) return;
  window.__jhCardPlus = true;

  var STORE = 'jhFrame2';
  var FILL_H = 0.80;   /* alto máximo que ocupa el reloj dentro de la caja */
  var FILL_W = 0.82;   /* ancho máximo */
  var MAX_ZOOM = 2.4;
  var cache = {};
  try { cache = JSON.parse(localStorage.getItem(STORE) || '{}') || {}; } catch (e) { cache = {}; }
  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        var keys = Object.keys(cache);
        if (keys.length > 1500) keys.slice(0, keys.length - 1500).forEach(function (k) { delete cache[k]; });
        localStorage.setItem(STORE, JSON.stringify(cache));
      } catch (e) {}
    }, 400);
  }

  function keyFor(src) {
    return String(src || '').replace(/^https?:\/\/[^/]+/, '').replace(/\?.*$/, '');
  }

  /* ---------- Medir el reloj dentro de la foto ---------- */
  var canvas = document.createElement('canvas');
  var ctx = null;
  function measure(img) {
    var iw = img.naturalWidth, ih = img.naturalHeight;
    if (!iw || !ih) return null;
    var scale = 120 / Math.max(iw, ih);
    var w = Math.max(8, Math.round(iw * scale)), h = Math.max(8, Math.round(ih * scale));
    canvas.width = w; canvas.height = h;
    ctx = ctx || canvas.getContext('2d', { willReadFrequently: true });
    var d;
    try {
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      d = ctx.getImageData(0, 0, w, h).data;
    } catch (e) { return { n: 1 }; }

    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    var corners = [px(1, 1), px(w - 2, 1), px(1, h - 2), px(w - 2, h - 2)];
    var bg = [0, 0, 0];
    corners.forEach(function (c) { bg[0] += c[0] / 4; bg[1] += c[1] / 4; bg[2] += c[2] / 4; });
    var transparent = corners.every(function (c) { return c[3] < 20; });
    var spread = corners.reduce(function (m, c) {
      return Math.max(m, Math.abs(c[0] - bg[0]), Math.abs(c[1] - bg[1]), Math.abs(c[2] - bg[2]));
    }, 0);
    /* Fondo de ambiente o esquinas muy distintas: no se toca */
    if (!transparent && (spread > 28 || (bg[0] + bg[1] + bg[2]) / 3 < 200)) return { n: 1 };

    var rows = new Array(h).fill(0), cols = new Array(w).fill(0);
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4;
        var on = transparent ? d[i + 3] > 24
          : (d[i + 3] > 24 && Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2])) > 26);
        if (on) { rows[y]++; cols[x]++; }
      }
    }
    var minRun = 2;
    var y0 = rows.findIndex(function (c) { return c >= minRun; });
    if (y0 < 0) return { n: 1 };
    var y1 = h - 1 - rows.slice().reverse().findIndex(function (c) { return c >= minRun; });
    var x0 = cols.findIndex(function (c) { return c >= minRun; });
    var x1 = w - 1 - cols.slice().reverse().findIndex(function (c) { return c >= minRun; });
    var b = [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h].map(function (v) { return Math.round(v * 1000) / 1000; });
    return { b: b, r: Math.round(iw / ih * 1000) / 1000 };
  }

  /* ---------- Aplicar el encuadre (transform con %: sirve en cualquier tamaño) ---------- */
  function apply(img, m, box, bw, bh) {
    img.style.transformOrigin = '';
    img.style.transform = '';
    if (m && m.b) {
      if (!bw || !bh) { bw = box.clientWidth; bh = box.clientHeight; }
      if (bw && bh) {
        var A = bw / bh, r = m.r;
        var dw, dh, ox, oy;
        if (r > A) { dw = 1; dh = A / r; ox = 0; oy = (1 - dh) / 2; } else { dh = 1; dw = r / A; oy = 0; ox = (1 - dw) / 2; }
        var cx0 = ox + m.b[0] * dw, cx1 = ox + m.b[2] * dw;
        var cy0 = oy + m.b[1] * dh, cy1 = oy + m.b[3] * dh;
        var cw = cx1 - cx0, ch = cy1 - cy0;
        if (cw > 0.02 && ch > 0.02) {
          /* Con muestras de variante abajo, el reloj sube un poco para dejarles espacio */
          var withSw = !!box.querySelector('.jh-sw');
          var fillH = withSw ? FILL_H - 0.1 : FILL_H;
          var targetY = withSw ? 0.43 : 0.5;
          var s = Math.min(FILL_W / cw, fillH / ch, MAX_ZOOM);
          s = Math.max(s, 0.9);
          var ccx = (cx0 + cx1) / 2, ccy = (cy0 + cy1) / 2;
          if (Math.abs(s - 1) > 0.03 || Math.abs(ccx - 0.5) > 0.01 || Math.abs(ccy - targetY) > 0.01) {
            img.style.transformOrigin = (ccx * 100).toFixed(2) + '% ' + (ccy * 100).toFixed(2) + '%';
            img.style.transform = 'translate(' + ((0.5 - ccx) * 100).toFixed(2) + '%,' + ((targetY - ccy) * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
          }
        }
      }
    }
    img.classList.add('is-framed');
  }

  /* ---------- Encuadre diferido: sin medir la página foto por foto ---------- */
  function showWhenLoaded(img) {
    if (img.complete && img.naturalWidth) return;
    img.classList.remove('is-framed');
    img.addEventListener('load', function () { img.classList.add('is-framed'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-framed'); }, { once: true });
  }
  var waiting = new Map(); /* caja -> fotos que esperan encuadre */
  var frameIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var box = en.target;
      var r = en.boundingClientRect;
      if (!en.isIntersecting || !r.width || !r.height) return;
      var imgs = waiting.get(box) || [];
      waiting.delete(box);
      frameIO.unobserve(box);
      imgs.forEach(function (img) {
        if (!img.isConnected) return;
        apply(img, cache[keyFor(img.currentSrc || img.getAttribute('src'))], box, r.width, r.height);
        showWhenLoaded(img);
      });
    });
  }, { rootMargin: '900px 0px' }) : null;

  function queueApply(img, box) {
    if (!frameIO) {
      apply(img, cache[keyFor(img.currentSrc || img.getAttribute('src'))], box);
      showWhenLoaded(img);
      return;
    }
    var list = waiting.get(box);
    if (!list) { list = []; waiting.set(box, list); frameIO.observe(box); }
    if (list.indexOf(img) === -1) list.push(img);
  }

  function frame(img) {
    if (img.__jhFramed) return;
    img.__jhFramed = true;
    var box = img.closest('.jh-card__media');
    if (!box) { img.classList.add('is-framed'); return; }
    var key = keyFor(img.currentSrc || img.getAttribute('src'));
    var known = cache[key];
    function done() {
      var k = keyFor(img.currentSrc || img.getAttribute('src'));
      if (!cache[k]) { var m = measure(img); if (m) { cache[k] = m; save(); } }
      queueApply(img, box);
    }
    if (known) {
      queueApply(img, box);
      return;
    }
    if (img.complete && img.naturalWidth) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-framed'); }, { once: true });
    }
  }

  function frameAll(root) {
    (root || document).querySelectorAll('.jh-card__img:not(.placeholder-svg)').forEach(frame);
    (root || document).querySelectorAll('.jh-card__media .placeholder-svg').forEach(function (s) { s.classList.add('is-framed'); });
  }

  /* Re-encuadre si cambia el tamaño de la caja (girar el celular, cambiar columnas) */
  /* En el celular, al bajar, la barra del navegador aparece y desaparece y eso dispara "resize"
     sin que cambie el ancho: en ese caso no hay nada que reencuadrar. */
  var resizeTimer = null;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      document.querySelectorAll('.jh-card__img.is-framed').forEach(function (img) {
        if (img.classList.contains('jh-card__img--next')) return;
        if (!cache[keyFor(img.currentSrc || img.getAttribute('src'))]) return;
        var box = img.closest('.jh-card__media');
        if (box) queueApply(img, box);
      });
    }, 150);
  });

  /* ---------- Variantes ---------- */
  function pick(btn) {
    var card = btn.closest('.jh-card');
    if (!card || btn.classList.contains('is-on')) return;
    var group = btn.closest('[data-jh-swatches]');
    group.querySelectorAll('.jh-sw__opt').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', String(on));
    });
    card.classList.add('jh-card--picked');
    card.setAttribute('data-variant-id', btn.getAttribute('data-id'));

    /* Enlaces y botón */
    var url = btn.getAttribute('data-url');
    card.querySelectorAll('a.jh-card__media-link, a.jh-card__title, a.jh-card__more').forEach(function (a) { a.setAttribute('href', url); });
    var input = card.querySelector('.add-to-cart-form input[name="id"]');
    if (input) input.value = btn.getAttribute('data-id');
    var avail = btn.getAttribute('data-available') === 'true';
    var cta = card.querySelector('.jh-card__btn');
    if (cta) {
      cta.disabled = !avail;
      var t = cta.querySelector('.add-to-cart-text');
      if (t) t.textContent = avail ? 'Agregar al carrito' : 'Agotado';
    }

    /* Precio */
    var reg = card.querySelector('.jh-price--regular');
    if (reg) {
      var now = reg.querySelector('.jh-price__now');
      var was = reg.querySelector('.jh-price__was');
      var cmp = btn.getAttribute('data-compare');
      if (now) {
        now.textContent = btn.getAttribute('data-price');
        now.classList.toggle('on-sale', !!cmp);
      }
      if (cmp) {
        if (!was) {
          was = document.createElement('span');
          was.className = 'jh-price__was grid-product__price--original';
          reg.appendChild(was);
        }
        was.innerHTML = '<span class="visually-hidden">Antes </span>' + cmp;
        was.hidden = false;
      } else if (was) {
        was.hidden = true;
      }
    }
    var campNow = card.querySelector('[data-jh-camp-price]');
    if (campNow && btn.getAttribute('data-camp')) campNow.textContent = btn.getAttribute('data-camp');
    var campWas = card.querySelector('[data-jh-camp-was]');
    if (campWas) campWas.textContent = btn.getAttribute('data-price');
    var sub = card.querySelector('.jh-card__sub');
    if (sub && btn.getAttribute('data-sub')) sub.textContent = btn.getAttribute('data-sub');
    var shipping = card.querySelector('[data-jh-card-shipping]');
    if (shipping) {
      shipping.setAttribute('data-price-cents', btn.getAttribute('data-price-cents'));
      shipping.setAttribute('data-available', String(avail));
      card.dispatchEvent(new CustomEvent('jherr:card-variant-change', { bubbles: true }));
    }

    /* Foto con fundido (se carga y encuadra antes de mostrarse) */
    var src = btn.getAttribute('data-img');
    var media = card.querySelector('.jh-card__media-link');
    var current = media && media.querySelector('.jh-card__img:not(.jh-card__img--hover):not(.is-leaving)');
    if (!src || !media || !current || keyFor(current.getAttribute('src')) === keyFor(src)) return;
    var next = new Image();
    next.className = 'jh-card__img jh-card__img--next';
    next.alt = btn.getAttribute('data-alt') || '';
    next.decoding = 'async';
    if (current.getAttribute('sizes')) next.sizes = current.getAttribute('sizes');
    if (btn.getAttribute('data-srcset')) next.srcset = btn.getAttribute('data-srcset');
    next.src = src;
    var token = (card.__jhSwap || 0) + 1;
    card.__jhSwap = token;
    var show = function () {
      if (card.__jhSwap !== token) return;
      next.__jhFramed = true;
      var k = keyFor(next.currentSrc || next.src);
      var m = cache[k];
      if (!m) { m = measure(next); if (m) { cache[k] = m; save(); } }
      apply(next, m, media.closest('.jh-card__media'));
      next.classList.remove('is-framed');
      media.insertBefore(next, current.nextSibling);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          next.classList.add('is-framed');
          current.classList.add('is-leaving');
        });
      });
      setTimeout(function () {
        if (current.parentNode) current.parentNode.removeChild(current);
        next.classList.remove('jh-card__img--next');
      }, 450);
    };
    (next.decode ? next.decode() : new Promise(function (r) { next.onload = r; })).then(show, show);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.jh-sw__opt');
    if (!btn) return;
    e.preventDefault();
    pick(btn);
  });
  /* En computadora, pasar el mouse por una muestra ya la previsualiza */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var hoverTimer = null;
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('.jh-sw__opt');
      if (!btn) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { pick(btn); }, 120);
    });
  }

  /* ---------- Arranque y tarjetas que llegan después (filtros, más productos) ---------- */
  function boot() { frameAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Solo la tanda nueva (antes se recorría toda la grilla en cada carga) */
  document.addEventListener('jherr:collection-products-loaded', function (e) {
    var d = e.detail || {};
    if (d.items && d.items.length) d.items.forEach(function (item) { frameAll(item); });
    else frameAll(d.container);
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('.jh-card__img:not(.jh-card__img--next)')) frame(n);
          else if (n.querySelector && n.querySelector('.jh-card__img')) frameAll(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
